module.exports = __webpack_public_path__ + "static/media/as_top.87b74b0a.png";